
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.5 19.5a.5.5 0 01-.354-.854L10.793 12 4.147 5.354a.5.5 0 01.707-.708l7 7a.5.5 0 010 .707l-7 7a.5.5 0 01-.354.147z"}}),_c('path',{attrs:{"d":"M12.5 19.5a.5.5 0 01-.353-.854L18.793 12l-6.646-6.646a.5.5 0 11.707-.708l7 7a.5.5 0 010 .707l-7 7a.5.5 0 01-.354.147z"}})])
          )
        }
      }
    